// extracted by mini-css-extract-plugin
export default {"carouselImage":"galleryCarousel_carouselImage__SlG+q","trash":"galleryCarousel_trash__Vo84t","carouselBtn":"galleryCarousel_carouselBtn__znH-P"};